import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ErrorTranslationService } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';

import { camps } from '../../../../../models/models.generated';
import { CampCareApiService } from '../../../../../services/api/camp-care-api.service';
import { CampCareFormMode } from '../camp-care.mode';
import { TextMaskService } from '@bayclubs/ui-text-mask';

@Component({
    selector: 'app-camp-care-day-single-edit',
    templateUrl: './camp-care-day-single-edit.component.html',
    styleUrls: ['./camp-care-day-single-edit.component.scss'],
    standalone: false
})
export class CampCareDaySingleEditComponent implements OnInit {
    @Input()
    public campForm: UntypedFormGroup;

    public editItem: camps.CampCareDayInfo;

    public form: UntypedFormGroup;
    public isBusy: boolean = false;
    public clubDropdownItems = [];

    public result: camps.CampCareDayInfo;

    constructor(
        public mask: TextMaskService,
        private campCareApi: CampCareApiService,
        private alert: BayclubsAlertService,
        private formBuilder: UntypedFormBuilder,
        private errorTranslate: ErrorTranslationService
    ) {}

    ngOnInit(): void {
        this.isBusy = true;

        this.initForms();
    }

    private initForms() {
        if (this.editItem) {
            this.form = this.formBuilder.group({
                ageInMonthsFrom: [this.editItem.ageRangeFromInMonths, [Validators.required]],
                ageInMonthsTo: [this.editItem.ageRangeToInMonths, [Validators.required]],
                campId: [this.campForm.value.basicInfo.id, [Validators.required]],
                date: [this.editItem.date, [Validators.required]],
                clubCode: [this.editItem.clubCode, [Validators.required]],
                slots: [this.editItem.slots, []],
                capacity: [this.editItem.capacity, []],
                mode: [CampCareFormMode.Edit, [Validators.required]],
                id: [this.editItem.id, []],
                ageInMonthsFromEffective: [this.editItem.ageRangeFromInMonthsEffective, [Validators.required]],
                ageInMonthsToEffective: [this.editItem.ageRangeToInMonthsEffective, [Validators.required]]
            });
        } else {
            this.form = this.formBuilder.group({
                ageInMonthsFrom: [12, [Validators.required]],
                ageInMonthsTo: [216, [Validators.required]],
                campId: [this.campForm.value.basicInfo.id, [Validators.required]],
                date: [null, [Validators.required]],
                clubCode: [[], [Validators.required]],
                slots: [[], []],
                capacity: [null, []],
                mode: [CampCareFormMode.AddNew, [Validators.required]],
                id: [null, []],
                ageInMonthsFromEffective: [12, [Validators.required]],
                ageInMonthsToEffective: [228, [Validators.required]]
            });
        }
    }

    private isEditMode(): boolean {
        return !!this.editItem;
    }

    public save(): void {
        if (this.form.invalid) return;

        var request = <camps.CampCareDaySaveRequest>{
            campId: this.form.value.campId,
            ageInMonthsFrom: this.form.value.ageInMonthsFrom,
            ageInMonthsTo: this.form.value.ageInMonthsTo,
            clubCode: this.form.value.clubCode,
            date: this.form.value.date,
            capacity: this.form.value.capacity,
            slots: this.form.value.slots,
            id: this.form.value.id,
            ageInMonthsFromEffective: this.form.value.ageInMonthsFromEffective,
            ageInMonthsToEffective: this.form.value.ageInMonthsToEffective
        };

        this.campCareApi.saveDay(request).subscribe(result => {
            if (result.isSuccess) {
                this.alert.showOperationSuccess();
                this.onClose(result.value);
            } else {
                this.errorTranslate.translateValidationNotifications(result.validationNotification);
                this.alert.showError(result.validationNotification.errors[0].message);
            }
        });
    }

    public onClose(result: camps.CampCareDayInfo) {
        this.result = result;
        console.log(this.result);
        this.closeModal();
    }

    close: Function;
    closeModal(): void {
        this.close();
    }
}
